// What VERA remembers about you: the notebook she keeps across conversations (Studio, voice and WhatsApp). Each
// person sees only their own, and can delete anything in it. Tell VERA "remember…" or "forget…" to change it too.

import { useEffect, useState } from "react";
import { cpFetch } from "../lib/controlPlane";
import { Icon, useStudio } from "./ui";
import { T } from "../lib/i18n";

type Fact = { id: string; text: string; added: number };

export function MemoryCard() {
  const { getToken, toast } = useStudio();
  const [facts, setFacts] = useState<Fact[] | null>(null);
  useEffect(() => { cpFetch<{ facts: Fact[] }>(getToken, "/v1/memory").then((r) => setFacts(r.facts)).catch(() => setFacts([])); }, [getToken]);

  async function forget(id: string) {
    try { await cpFetch(getToken, `/v1/memory/${encodeURIComponent(id)}`, { method: "DELETE" }); setFacts((xs) => (xs ?? []).filter((f) => f.id !== id)); }
    catch (e) { toast(e instanceof Error ? e.message : T("Something went wrong.")); }
  }

  return (
    <section className="card stack">
      <details className="help-fix">
        <summary><Icon name="history" size={14} /> {T("What VERA remembers about you")}{facts?.length ? ` (${facts.length})` : ""}</summary>
        <p className="mute">{T("VERA remembers your conversations, in Studio, by voice and on WhatsApp, and keeps a short notebook of what matters to you. Only you see it. Tell her \"remember…\" or \"forget…\", or delete anything here.")}</p>
        {facts === null ? <p className="faint">{T("Loading…")}</p> : !facts.length ? <p className="faint">{T("Nothing yet.")}</p> : (
          <div className="list">{facts.map((f) => (
            <div className="li" key={f.id}>
              <span className="grow">{f.text}</span>
              <button className="iconbtn ghost" onClick={() => void forget(f.id)} aria-label={T("Forget this")} title={T("Forget this")}><Icon name="x" size={14} /></button>
            </div>))}
          </div>)}
      </details>
    </section>
  );
}
